import React, { FunctionComponent, useState } from "react"

import { ArticleAny } from "@/types"
import Asset, { AssetOwnershipType } from "models/Asset"
import { AssetStoredStatus as AssetStoredStatusEnum } from "models/AssetDisplayStatus"
import CopyAssetOwnershipModal from "./CopyAssetOwnershipModal"
import CopyAssetModal from "./CopyAssetModal"

export interface ICopyAssetFlowProps {
    asset: Asset
    article: ArticleAny
    storedStatus?: AssetStoredStatusEnum | null
    onClose(): void
}

/**
 * Drives the multi-step copy flow of an asset: ownership selection, the copy
 * dialog with one editable card per copy, the confirmation and the per-copy
 * creation results.
 *
 * The ownership choice is taken first because both dropdown matrices of the copy
 * dialog depend on it, so the dialog cannot be built before it is known.
 */
const CopyAssetFlow: FunctionComponent<React.PropsWithChildren<ICopyAssetFlowProps>> = ({
    asset,
    article,
    storedStatus,
    onClose,
}) => {
    const [selection, setSelection] = useState<{ ownershipType: AssetOwnershipType, isSecondhand: boolean } | null>(null)

    if (!selection) {
        return (
            <CopyAssetOwnershipModal
                sourceIsSecondhand={asset.isSecondhand}
                onConfirm={(ownershipType, isSecondhand) => setSelection({ ownershipType, isSecondhand })}
                onClose={onClose}
            />
        )
    }

    return (
        <CopyAssetModal
            asset={asset}
            article={article}
            ownershipType={selection.ownershipType}
            isSecondhand={selection.isSecondhand}
            storedStatus={storedStatus}
            onClose={onClose}
        />
    )
}

export default CopyAssetFlow
